<!--suppress XmlInvalidId -->
<template>
  <ws-modal-dialog :on-close="handleClose" focused="email">
    <div class="modal-header">
      <span class="modal-title" id="exampleModalLabel">Password Reset</span>
      <button @click="closeModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <div class="alert alert-warning modal-alert">
          <p class="alert-heading">A request was made to reset the password for:</p>

          {{ email }}
        </div>
        <form role="form">
          <div class="form-group">
            <label for="email">Your New Password</label>
            <ws-text-input type="password" name="password" field="password" v-model="password"/>
          </div>
          <div class="form-group">
            <label for="email">Repeat Password</label>
            <ws-text-input type="password" name="repeat_password" field="repeat_password" v-model="repeatPassword"/>
          </div>
          <!-- The id for popup dialog buttons must be unique to the application -->
          <ws-signal-button id="login-password-reset-submit-btn" class="btn btn-primary modal-submit" text="Reset Password"
                            data-dismiss="modal"
                            :disabled="!canSubmit()" :aria-disabled="!canSubmit()"
                            :onSubmit="handleSubmit"/>
        </form>
        <p class="m-t text-muted">
          <small>&copy; {{ copyright }}</small>
        </p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-sm modal-close" @click="closeModal" data-dismiss="modal">Close
      </button>
    </div>
  </ws-modal-dialog>
</template>

<script>
import WsModalDialog from '@/views/dialog/ModalDialog'
import ApiService from '@/common/api.service'

export default {
  name: 'LoginSupportRequest',
  data () {
    return {
      password: '',
      repeatPassword: ''
    }
  },

  methods: {
    canSubmit () {
      return true
    },

    closeModal () {
      this.$parent.$emit('closeLoginPasswordReset')
    },

    handleSubmit () {
      // Save data
      ApiService
        .post('auth/pwd-reset', {
          email: this.email,
          password: this.password,
          repeat_password: this.repeatPassword,
          token: this.getToken()
        })
        .then((response) => {
          this.closeModal()
          return response
        })
    },

    handleClose () {
      this.closeModal()
    },

    getToken () {
      if (typeof this.$route.query.token !== 'undefined') {
        return this.$route.query.token
      } else {
        return ''
      }
    }
  },

  computed: {
    copyright () {
      return process.env.COPYRIGHT
    },

    email () {
      if (typeof this.$route.query.email !== 'undefined') {
        return this.$route.query.email
      } else {
        return ''
      }
    }
  },
  components: {
    WsModalDialog
  }
}
</script>

<style scoped>
  .alert-heading {
    margin-bottom: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/support/LoginPasswordReset.vue